import type React from 'react';
import '@rmwc/textfield/styles';
import 'material-icons/iconfont/material-icons.css';
import {
  TextField as RMWCTextField,
  type TextFieldProps as RMWCTextFieldProps,
  type TextFieldHTMLProps,
} from '@rmwc/textfield';
import clsx from 'clsx';
import styles from './TextField.module.scss';

const TextField = (
  props: Partial<RMWCTextFieldProps & TextFieldHTMLProps>,
): React.JSX.Element => (
  <div
    className={clsx(
      props.className,
      styles.textFieldContainer,
      props.helpText && styles.hasHelpText,
    )}
  >
    <RMWCTextField
      {...props}
      className=""
    />
  </div>
);

export {TextField};
